import { useStyles } from '@team-griffin/stylr';
import { cssTheme, gu2px, Theme } from '@uds/theme-utils';
import { css, cx } from 'linaria';

const pageNavControls = {
  default: css`
    margin-top: ${cssTheme.gu1};
    &&& ${cssTheme.breakpoints.sm} {
      margin-top: ${cssTheme.gu2};
    }
  `,
  showNavigation: css`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  `,
};
export const getClassNames = ({ showNavigation }: { showNavigation: boolean }) => {
  return {
    pageNavControls: cx(pageNavControls.default, showNavigation && pageNavControls.showNavigation),
  };
};
export default ({ theme: { spacing } }: { theme: Theme }) => {
  return useStyles(
    {
      default: {
        root: {
          position: 'relative',
          overflow: 'hidden',
        },
        clickZone: {
          position: 'absolute',
          // arbitrary number high enough to fill the void off screen
          width: '20%',
          left: '100%',
          top: 0,
          bottom: 0,
          // 4gu clickable target
          marginLeft: 0 - gu2px(4, spacing),
        },
      },
    },
    {},
  );
};
